// src/i18n.js
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files
import enTranslation from './locales/en/translation.json';

import esTranslation from './locales/es/translation.json';
import frTranslation from './locales/fr/translation.json'; 
import deTranslation from './locales/de/translation.json';
import nlTranslation from './locales/nl/translation.json';
import itTranslation from './locales/it/translation.json';
import plTranslation from './locales/pl/translation.json';
const resources = {
  en: {
    translation: enTranslation,
  },

  es: {
    translation: esTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  de:{
    translation:deTranslation,
  },
  nl:{translation:nlTranslation,},
  it:{translation:itTranslation,},
  pl:{translation:plTranslation,},
};

i18n
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    resources,
    fallbackLng: 'en', 
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['queryString', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
    },
  });

export default i18n;